module.exports = __webpack_public_path__ + "static/media/widget3.315d4bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/adminPanel/Content Management/assets/widget3.png
// module id = 1417
// module chunks = 1